var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddNewCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5ZM12 20.1667C11.4477 20.1667 11 19.719 11 19.1667V13.5H5.33398C4.7817 13.5 4.33398 13.0523 4.33398 12.5C4.33398 11.9477 4.7817 11.5 5.33398 11.5H11V5.83334C11 5.28106 11.4477 4.83334 12 4.83334C12.5523 4.83334 13 5.28106 13 5.83334V11.5H18.6673C19.2196 11.5 19.6673 11.9477 19.6673 12.5C19.6673 13.0523 19.2196 13.5 18.6673 13.5H13V19.1667C13 19.719 12.5523 20.1667 12 20.1667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddNewCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-new-card-icon.51b7bdf61286b88067159d206314ad40.svg";